export const AB_TESTING_KEY_PREFIX = 'grant-connect-ab-testing-'

export const resetSessionVersionData = () => {
  for (const key of Object.keys(window.localStorage)) {
    if (key.startsWith(AB_TESTING_KEY_PREFIX)) {
      window.localStorage.removeItem(key)
    }
  }
}

export const getSessionActiveVersion = (key, choices) => {
  let version = window.localStorage.getItem(`${AB_TESTING_KEY_PREFIX}${key}`)
  if (!version) {
    version = choices[Math.floor(Math.random() * choices.length)]
    window.localStorage.setItem(`${AB_TESTING_KEY_PREFIX}${key}`, version)
  }
  return version
}
